const EmployeeService = require("@/services/users/EmployeeService");

export default function(cb, preset) {

    let value = null;

    const data = {
        includes: ["department"],
        sort: [
            {
                key: "name",
                direction: "ASC"
            }
        ],
        filter_groups: [
            {
                filters: [
                    {
                        key: "terminated",
                        value: 0,
                        operator: "eq"
                    }
                ]
            }
        ]
    };

    EmployeeService.findAll(data, response => {
        const body = response.data;

        // Convert object to array if necessary
        const rowsArray = body.rows && typeof body.rows === 'object' ?
            Object.values(body.rows) : [];

        const results = rowsArray.map(employee => ({
            label: employee.name,
            value: employee.id
        }));

        // If we have a preset (current user), move them to the top
        if (preset) {
            const currentUserIndex = results.findIndex(r => r.value === preset);
            if (currentUserIndex !== -1) {
                const currentUser = results.splice(currentUserIndex, 1)[0];
                results.unshift(currentUser);
                value = preset;
            }
        }

        cb(results, value);
    });
}
